import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "rentComponent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_DatepickerComponent = _resolveComponent("DatepickerComponent")!
  const _component_PassengersComponent = _resolveComponent("PassengersComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.roundTrip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_SearchInput, {
              id: "journey-from",
              "place-holder": _ctx.$t('drive_from'),
              "pickup-address": true,
              cities: _ctx.transportationAddressesDataFalseRoundFirst,
              "selected-city": _ctx.store.state.orderFalseRoundTrip.pickUp,
              message: _ctx.messagesTrip.validLocationStart,
              onGetCity: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getCity($event)))
            }, null, 8, ["place-holder", "cities", "selected-city", "message"]),
            _createVNode(_component_SearchInput, {
              id: "journey-to",
              "place-holder": _ctx.$t('drive_to'),
              "is-disabled-input": _ctx.isDisabledSecondInput,
              cities: _ctx.transportationAddressesDataFalseRoundSecond,
              "selected-city": _ctx.store.state.orderFalseRoundTrip.dropOff,
              message: _ctx.messagesTrip.validLocationDestination,
              onGetCity: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCity($event)))
            }, null, 8, ["place-holder", "is-disabled-input", "cities", "selected-city", "message"]),
            _createVNode(_component_DatepickerComponent, {
              "datepicker-translation": _ctx.$t('departure'),
              "default-date": _ctx.tomorrow,
              "pickup-date": true,
              "date-store": _ctx.store.state.orderFalseRoundTrip.tripDepartureDate,
              onGetDate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDate($event)))
            }, null, 8, ["datepicker-translation", "default-date", "date-store"]),
            _createVNode(_component_PassengersComponent, {
              "passengers-store": _ctx.store.state.orderFalseRoundTrip.tripPassengers,
              onGetPassengers: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getPassengers($event)))
            }, null, 8, ["passengers-store"]),
            ([_ctx.routesConst.HOME, _ctx.routesConst.TRIPS, _ctx.routesConst.SERVICES_IFRAME].includes(_ctx.$route.name))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                  disabled: _ctx.disabled,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit($event, _ctx.$route.name)))
                }, [
                  _createVNode(_component_router_link, { to: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
                    ]),
                    _: 1
                  })
                ], 10, _hoisted_3))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.roundTrip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SearchInput, {
              id: "journey-from",
              "place-holder": _ctx.$t('drive_from'),
              "pickup-address": true,
              cities: _ctx.transportationAddressesDataTrueRoundFirst,
              "selected-city": _ctx.store.state.orderTrueRoundTrip.pickUp,
              message: _ctx.messagesRound.validLocationStart,
              onGetCity: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCity($event)))
            }, null, 8, ["place-holder", "cities", "selected-city", "message"]),
            _createVNode(_component_SearchInput, {
              id: "journey-to",
              "place-holder": _ctx.$t('drive_to'),
              "is-disabled-input": _ctx.isDisabledSecondInput,
              cities: _ctx.transportationAddressesDataTrueRoundSecond,
              "selected-city": _ctx.store.state.orderTrueRoundTrip.dropOff,
              message: _ctx.messagesRound.validLocationDestination,
              onGetCity: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getCity($event)))
            }, null, 8, ["place-holder", "is-disabled-input", "cities", "selected-city", "message"]),
            _createVNode(_component_DatepickerComponent, {
              "datepicker-translation": _ctx.$t('departure'),
              "default-date": _ctx.tomorrow,
              "pickup-date": true,
              "date-store": _ctx.store.state.orderTrueRoundTrip.tripDepartureDate,
              "is-valid": _ctx.messagesRound.validDate.state,
              message: _ctx.messagesRound.validDate.message,
              onGetDate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getDate($event)))
            }, null, 8, ["datepicker-translation", "default-date", "date-store", "is-valid", "message"]),
            _createVNode(_component_DatepickerComponent, {
              "datepicker-translation": _ctx.$t('the_return'),
              "default-date": _ctx.week,
              "date-store": _ctx.store.state.orderTrueRoundTrip.tripArrivalDate,
              "is-valid": _ctx.messagesRound.validDate.state,
              message: _ctx.messagesRound.validDate.message,
              onGetDate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getDate($event)))
            }, null, 8, ["datepicker-translation", "default-date", "date-store", "is-valid", "message"]),
            _createVNode(_component_PassengersComponent, {
              "passengers-store": _ctx.store.state.orderTrueRoundTrip.tripPassengers,
              onGetPassengers: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getPassengers($event)))
            }, null, 8, ["passengers-store"]),
            ([_ctx.routesConst.HOME, _ctx.routesConst.ROUND_TRIP_FIRST_STEP, _ctx.routesConst.ROUND_TRIP_SECOND_STEP, _ctx.routesConst.SERVICES_IFRAME].includes(_ctx.$route.name))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                  disabled: _ctx.disabled,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSubmit($event, _ctx.$route.name)))
                }, [
                  _createVNode(_component_router_link, { to: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                    ]),
                    _: 1
                  })
                ], 10, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backEndErrorMessages, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "custom-route-error-color font-small",
        key: error
      }, _toDisplayString(_ctx.$t(error)), 1))
    }), 128))
  ], 64))
}